import { clsx } from 'clsx'
import { useEffect, useRef } from 'react'
import { scrollableBlock } from './index.css'

export const Scrollable = (props: {
  className?: string
  children: React.ReactNode
  initScrollPosition?: 'bottom'
}) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (props.initScrollPosition === 'bottom' && containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight
    }
  }, [props.initScrollPosition, containerRef.current?.scrollHeight])

  return (
    <div
      ref={containerRef}
      className={clsx(scrollableBlock, props.className)}
    >
      {props.children}
    </div>
  )
}
